/**
 * 存储localStorage
 */
export const storage = {
	setLoc: function (name, content) {
		if (!name) return;
		if (typeof content !== 'string') {
			content = JSON.stringify(content);
		}
		window.localStorage.setItem(name, content);
	},

	/**
	 * 获取localStorage
	 */
	getLocal: function (name) {
		if (!name) return;
		return window.localStorage.getItem(name);
	},

	/**
	 * 删除localStorage
	 */
	removeLocal: function (name) {
		if (!name) return;
		window.localStorage.removeItem(name);
	},
	/**
	 * 存储sessionStorage
	 */
	setSession: function (name, content) {
		if (!name) return;
		if (typeof content !== 'string') {
			content = JSON.stringify(content);
		}
		window.sessionStorage.setItem(name, content);
	},

	/**
	 * 获取sessionStorage
	 */
	getSession: function (name) {
		if (!name) return;
		return window.sessionStorage.getItem(name);
	},

	/**
	 * 删除sessionStorage
	 */
	removeSession: function (name) {
		if (!name) return;
		window.sessionStorage.removeItem(name);
	}
};

export const cookie = {
	/**
	 * 存cookie
	 */
	setCookie(name, value) {
		var Days = 30;
		var exp = new Date();
		exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
		document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
	},
	/**
	 * 取cookie
	 */
	getCookie(name) {
		var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		if (arr = document.cookie.match(reg))
			return unescape(arr[2]);
		else
			return null;
	},
	/**
	 * 删所有cookie
	 */
	clearCookie(){
		var keys=document.cookie.match(/[^ =;]+(?=\=)/g);
		if (keys) {
			for (var i =  keys.length; i--;)
				document.cookie=keys[i]+'=0;expires=' + new Date( 0).toUTCString();
		}
	},
};

export const DateUtil = {
	isLeapYear: function (date) {
		return (date.getYear() % 4 === 0 && ((date.getYear() % 100 !== 0) || (date.getYear() % 400 === 0)));
	},
	/**
	 * 格式化日期
	 */
	formatDate: function (date, fmt) {
		var yyyy = date.getFullYear();
		var MM = date.getMonth();
		var dd = date.getDate();
		var HH = date.getHours();
		var mm = date.getMinutes();
		var ss = date.getSeconds();
		var hh = HH > 12 ? HH - 12 : HH;
		var dateStr = fmt.replace('yyyy', yyyy).replace('MM', this.addZero(MM + 1)).replace('dd', this.addZero(dd))
			.replace('HH', this.addZero(HH)).replace('mm', this.addZero(mm)).replace('ss', this.addZero(ss))
			.replace('hh', this.addZero(hh));
		return dateStr;
	},

	addZero: function (num) {
		if (num < 10) {
			return '0' + num;
		}
		return num;
	},

	/**
	 * 将日期字符串转成日期 fmt：yyyy-MM-dd HH:mm:ss 或 yyyy-MM-dd
	 */
	parseDate: function (str, fmt) {
		if (!str) {
			return null;
		}
		var date;
		var year = 0;
		var month = 0;
		var day = 0;
		var hour = 0;
		var minute = 0;
		var second = 0;
		var tempStrs = str.split(' ');
		if (tempStrs[0]) {
			var dateStrs = tempStrs[0].split("-");
			year = parseInt(dateStrs[0], 10);
			month = parseInt(dateStrs[1], 10) - 1;
			day = parseInt(dateStrs[2], 10);
		}
		if (tempStrs[1]) {
			var timeStrs = tempStrs[1].split(":");
			hour = parseInt(timeStrs[0], 10);
			minute = parseInt(timeStrs[1], 10);
			second = parseInt(timeStrs[2], 10);
		}

		if (fmt === 'yyyy-MM-dd') {
			date = new Date(year, month, day);
			return date;
		} else if (fmt === 'yyyy-MM-dd HH:mm:ss') {
			date = new Date(year, month, day, hour, minute, second);
			return date;
		}
		return null;
	},
	/**
	 * 获取指定日期最后一天日期
	 */
	getLastDate: function (date) {
		date = arguments[0] || new Date();
		var newDate = new Date(date.getTime());
		newDate.setMonth(newDate.getMonth() + 1);
		newDate.setDate(1);
		var time = newDate.getTime() - 24 * 60 * 60 * 1000;
		newDate = new Date(time);
		return newDate;
	},
	/**
	 * 获取日期差
	 */
	getDateDiff: function (start, end) {
		return Math.round(Math.abs(start - end) / (1000 * 60 * 60 * 24));
	},
	/**
	 * 获取指定日期第一天日期
	 */
	getFirstDate: function (date) {
		date = arguments[0] || new Date();
		var newDate = new Date(date.getTime());
		newDate.setDate(1);
		return newDate;
	},
	/**
	 * 获取周的第一天
	 */
	getWeekStartDate: function (date) {
		date = arguments[0] || new Date();
		return new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 1);
	},
	/**
	 * 获取周的最后一天
	 */
	getWeekEndDate: function (date) {
		date = arguments[0] || new Date();
		return new Date(date.getFullYear(), date.getMonth(), date.getDate() + (6 - date.getDay() + 1));
	},
	/**
	 * 日期计算
	 *
	 * @param strInterval
	 *            string 可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
	 * @param num
	 *            int
	 * @param date
	 *            Date 日期对象
	 * @return Date 返回日期对象
	 */
	dateAdd: function (strInterval, num, date) {
		date = arguments[2] || new Date();
		/* eslint-disable */
		switch (strInterval) {
			case 's':
				return new Date(date.getTime() + (1000 * num));
			case 'n':
				return new Date(date.getTime() + (60000 * num));
			case 'h':
				return new Date(date.getTime() + (3600000 * num));
			case 'd':
				return new Date(date.getTime() + (86400000 * num));
			case 'w':
				return new Date(date.getTime() + ((86400000 * 7) * num));
			case 'm':
				return new Date(date.getFullYear(), (date.getMonth()) + num, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
			case 'y':
				return new Date((date.getFullYear() + num), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
		}
		/* eslint-enable */

	}
};

export const PageInfo = {
	getPageInfo: function (pageInfo) {
		var total = pageInfo.dataCount || 0;
		var num = total % pageInfo.pageLimit;
		var totalPage = (num === 0 ? total / pageInfo.pageLimit : Math.ceil(total / pageInfo.pageLimit));
		return Object.assign({}, pageInfo, {totalPage: totalPage})
	}
};


export const Validator = {
	isEmail: function (str) {
		if (str === '') {
			return true;
		}

		if (str.charAt(0) === "." || str.charAt(0) === "@" || str.indexOf('@', 0) === -1 || str.indexOf('.', 0) === -1 || str.lastIndexOf("@") === str.length - 1 || str.lastIndexOf(".") === str.length - 1) {
			return false;

		} else {
			return true;
		}
	},
	/**
	 * 判断是否是日期
	 */
	isDate: function (date, fmt) {
		if (date === '') {
			return true;
		}
		if (fmt === null) {
			fmt = "yyyy-MM-dd";
		}
		var yIndex = fmt.indexOf("yyyy");
		if (yIndex === -1) {
			return false;
		}
		var year = date.substring(yIndex, yIndex + 4);
		var mIndex = fmt.indexOf("MM");
		if (mIndex === -1) {
			return false;
		}
		var month = date.substring(mIndex, mIndex + 2);
		var dIndex = fmt.indexOf("dd");
		if (dIndex === -1) {
			return false;
		}
		var day = date.substring(dIndex, dIndex + 2);
		if (!Validator.isNumber(year) || year > 2100 || year < 1900) {
			return false;
		}
		if (!Validator.isNumber(month) || month > 12 || month < 1) {
			return false;
		}
		if (day > Validator.getMaxDay(year, month) || day < 1) {
			return false;
		}
		return true;
	},

	/**
	 * 检查输入字符串是否符合正整数格式
	 *
	 */
	isNumber: function (s) {
		if (s === '') {
			return true;
		}

		var regu = "^[0-9]+$";
		var re = new RegExp(regu);
		if (s.search(re) !== -1) {
			return true;
		} else {
			return false;
		}
	},

	/**
	 * 检查输入字符串是否是带小数的数字格式,可以是负数
	 *
	 */
	isDecimal: function (str) {

		if (Validator.isInteger(str)) {
			return true;
		}

		var re = /^[-]{0,1}(\d+)[\.]+(\d+)$/;
		if (re.test(str)) {

			if (RegExp.$1 === 0 && RegExp.$2 === 0) {
				return false;
			}

			return true;

		} else {
			return false;
		}
	},

	/**
	 * 检查是否是Money
	 *
	 */
	isMoney: function (str) {
		if (str === '') {
			return true;
		}

		if (/^\d+($|\.\d+$)/.test(str)) {
			return true;
		} else {
			return false;
		}
	},
	/**
	 * 校验字符串是否为整型
	 *
	 */
	isInteger: function (str) {
		if (str === '') {
			return true;
		}

		if (/^(\-?)(\d+)$/.test(str)) {
			return true;
		} else {
			return false;
		}
	},

	getPhoneType: function (phone) {
		var ltReg = /^1(3[0-2]|5[5|6]|8[5|6]|4[5]|7[5|6])\d{8}$|^170[7|8|9]\d{7}$/;

		var dxReg = /^1(3[3]|5[3]|7[3|7]|8[01]|8[9])\d{8}$|^170[0|1|2]\d{7}$/;

		var ydReg = /^1(3[4-9]|5[0-2]|5[4]|5[7-9]|7[8]|8[2|3|4|7|8]|4[7])\d{8}$|^170[3|5|6]\d{7}$/;

		var xlReg = /^0\d{2,3}\d{8}$/;


		if (ltReg.test(phone)) {
			return 1;
		}
		if (dxReg.test(phone)) {
			return 2;
		}
		if (ydReg.test(phone)) {
			return 3;
		}
		if (xlReg.test(phone)) {
			return 4;
		}

		return -1;
	},
	/**
	 * 校验字符串是否为合法手机号码
	 *
	 */
	isPhone: function (str) {
		if (str === '') {
			return true;
		}
		if (Validator.getPhoneType(str) !== -1) {
			return true;
		} else {
			return false;
		}
	},

	/**
	 * 检查输入字符串是否只由英文字母和数字和下划线组成
	 *
	 */
	isNumberOrLetter: function (s) {

		var regu = "^[0-9a-zA-Z\_]+$";
		var re = new RegExp(regu);
		if (re.test(s)) {
			return true;
		} else {
			return false;
		}
	},

	/**
	 * 检查输入字符串是否为空或者全部都是空格
	 */
	isEmpty: function (str) {
		if (str === "") {
			return true;
		}
		var regu = "^[ ]+$";
		var re = new RegExp(regu);
		return re.test(str);
	},

	/**
	 * 判断是否是非法字符，即不含特殊字符
	 *
	 */
	isNormal: function (str) {
		if (str === '') {
			return true;
		}
		var reg = '~!#$%^&*()+{}|\'<>?`=[]/\。；;，,';
		for (var i = 0; i < reg.length; i++) {
			if (str.indexOf(reg.charAt(i)) !== -1) {
				return false;
			}
		}
		return true;
	},

	/**
	 * 判断是否含有html字符
	 *
	 */
	isHtmlChar: function (str) {
		if (str === '') {
			return true;
		}
		var reg = '&\'<>/\\';
		for (var i = 0; i < reg.length; i++) {
			if (str.indexOf(reg.charAt(i)) !== -1) {
				return true;
			}
		}
		return false;
	},

	/**
	 * 判断是否是汉字
	 *
	 */
	isChinese: function (str) {
		if (str === '') {
			return true;
		}
		if (/[^\u4e00-\u9fa5]/.test(str)) {
			return false;
		} else {
			return true;
		}
	}
}





// WEBPACK FOOTER //
// ./src/assets/js/utils.js